import React from 'react';

const NoFeedbackSubOptions = (props) => {
  const subNoOptionData = props.childrenArry
  
    return (
       <div className='suboptions'>

         <p>何をお探しでしたか？</p>

         {subNoOptionData.map((suboption)=>(

         <div key={suboption.optionId}><label><input type="radio" onChange={props.handleInputChange} className='option-input' name="noFeedbackOptionID" id="noFeedbackOptionID" value={suboption.optionId} />{suboption.optionName}</label></div>

         ))}

       </div>
       
      
    );
  }

  
export default NoFeedbackSubOptions;